import { useEffect, useState } from 'react';
import { fmtDateTime } from '../utils/format';
import { getLeaveHistory, adjustLeave } from '../api/leave';

const TYPE = { accrue: 'Cộng tháng', reset: 'Reset cuối năm', manual: 'Chỉnh tay', use: 'Nghỉ phép', refund: 'Hoàn phép' };

// Lịch sử sử dụng phép của 1 NV. Giám đốc có thể cộng/trừ tay.
export default function LeaveHistoryModal({ user, isGD, onClose, onChanged }) {
  const [data, setData] = useState(null);
  const [amount, setAmount] = useState('');
  const [note, setNote] = useState('');
  const [busy, setBusy] = useState(false);

  const load = () => getLeaveHistory(user.id).then(setData).catch(() => {});
  useEffect(() => { load(); }, []); // eslint-disable-line

  async function doAdjust() {
    const a = Number(amount);
    if (!a) return;
    setBusy(true);
    try { await adjustLeave(user.id, a, note.trim()); setAmount(''); setNote(''); load(); onChanged && onChanged(); }
    catch (e) { alert(e.response?.data?.message || 'Lỗi'); }
    finally { setBusy(false); }
  }

  return (
    <div style={{ minWidth: 380 }}>
      <span className="close" onClick={onClose}>×</span>
      <h3 style={{ marginTop: 0 }}>🏖 Ngày phép — {user.name}</h3>
      <div style={{ marginBottom: 10 }}>Quỹ hiện tại: <b style={{ fontSize: 18, color: 'var(--accent)' }}>{data ? data.balance : '…'}</b> ngày</div>

      {isGD && (
        <div className="card" style={{ background: 'var(--panel2)', marginBottom: 12 }}>
          <div className="small muted" style={{ marginBottom: 6 }}>Giám đốc cộng/trừ tay (dùng số âm để trừ):</div>
          <div className="row" style={{ gap: 6, flexWrap: 'wrap' }}>
            <input type="number" step="0.5" value={amount} onChange={(e) => setAmount(e.target.value)} placeholder="vd 1 hoặc -0.5" style={{ width: 120 }} />
            <input value={note} onChange={(e) => setNote(e.target.value)} placeholder="Ghi chú" style={{ flex: 1, minWidth: 120 }} />
            <button className="btn sm" disabled={busy || !Number(amount)} onClick={doAdjust}>Áp dụng</button>
          </div>
        </div>
      )}

      <div style={{ maxHeight: 320, overflow: 'auto' }}>
        <table style={{ width: '100%', fontSize: 12.5 }}>
          <thead><tr><th>Thời gian</th><th>Loại</th><th className="r">Thay đổi</th><th className="r">Còn lại</th><th>Ghi chú</th></tr></thead>
          <tbody>
            {data?.items?.length ? data.items.map((t) => (
              <tr key={t._id}>
                <td className="small">{fmtDateTime(t.createdAt)}</td>
                <td>{TYPE[t.type] || t.type}</td>
                <td className="r" style={{ color: t.amount >= 0 ? 'var(--ok)' : 'var(--danger)', fontWeight: 600 }}>{t.amount >= 0 ? '+' : ''}{t.amount}</td>
                <td className="r">{t.balanceAfter}</td>
                <td className="small muted">{t.note}{t.byName ? ` · ${t.byName}` : ''}</td>
              </tr>
            )) : <tr><td colSpan={5} className="empty">Chưa có lịch sử.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
